/**
 * author antoine.nivet
 */
export default function slugifyService($filter) {
  return {
    slugify: slugify,
  };

  function slugify(input) {
    if (!input) {
      return;
    }

    // make lower case and trim
    let slug = lowerCaseAndTrim(input);
    slug = removeAccents(slug);
    slug = replaceUmlauts(slug);
    slug = replaceEszett(slug);
    slug = replaceInvalidCharsWithSpaces(slug);
    slug = replaceApostrophesWithDashes(slug);
    slug = replaceSpacesWithHyphen(slug);

    return slug;
  }

  function removeAccents(slug) {
    return $filter('removeAccents')(slug);
  }

  function replaceUmlauts(slug) {
    return slug
      .replace(/ä/gi, 'ae')
      .replace(/ö/gi, 'oe')
      .replace(/ü/gi, 'ue');
  }

  function replaceEszett(slug) {
    return slug.replace(/ß/gi, 'ss');
  }

  function replaceInvalidCharsWithSpaces(slug) {
    return slug.replace(/[^a-z0-9\'\s-]/g, '');
  }

  function replaceApostrophesWithDashes(slug) {
    return slug.replace(/'/g, '-');
  }

  function replaceSpacesWithHyphen(slug) {
    return slug.replace(/[\s-]+/g, '-');
  }

  function lowerCaseAndTrim(input) {
    return input.toLowerCase().trim();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/slugify.service.js